<div class="loading-overlay" *ngIf="isLoading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>{{ message }}</p>
</div>
